/** Auth0 SPA cache key for the signed ID token (`@@user@@` entry). */
export function auth0UserCacheKey(clientId: string): string {
  return `@@auth0spajs@@::${clientId}::@@user@@`
}

/** Read the raw Auth0 ID token from SPA localStorage (same store as @auth0/auth0-spa-js). */
export function readAuth0IdTokenFromCache(clientId: string): string | null {
  try {
    const raw = localStorage.getItem(auth0UserCacheKey(clientId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as { id_token?: string }
    return typeof parsed.id_token === 'string' && parsed.id_token.trim() ? parsed.id_token.trim() : null
  } catch {
    return null
  }
}
